import { Box, Divider, Typography } from '@mui/joy';
import MainPageTemplate from '../../components/MainPageTemplate';
import BedSensorsTable from './BedSensorsTable';

function AllBedSensorsPage() {
  return (
    <MainPageTemplate title="Bed Sensors">
      <Box sx={{ pt: 2, pb: 2, pl: 2, pr: 2 }}>
        <Box sx={{ pl: 2, pr: 2 }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              pt: 2,
              pb: 2,
              justifyContent: 'space-between',
            }}
          >
            <Box>
              <Typography level="h1">Bed Sensors</Typography>
            </Box>
          </Box>
        </Box>
        <Divider sx={{ mb: 2 }} />
        <Box sx={{ pl: 2, pr: 2 }}>
          <BedSensorsTable />
        </Box>
      </Box>
    </MainPageTemplate>
  );
}

export default AllBedSensorsPage;
